// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__n0akx","buttons":"Footer_buttons__2WVZB"};